<!-- 🔴 STANDARD MODAL HEADER STRUCTURE (SuperPrompt V6) -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- 🔴 STANDARD MODAL BODY STRUCTURE (SuperPrompt V6) -->
<div class="modal-body" style="padding-top: 0 !important;" [hidden]="minimise">
  <!-- Loader -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  <br>
  
  <!-- Main Content Table -->
  @if (!loading) {
<table class="table table-bordered form-inline InnerTblBG">
    <thead>
      <tr class="row">
        <th class="row">
          <p>S No</p>
        </th>
        <th class="row">
          <p>Acct Description</p>
        </th>
        <th class="row">
          <p>Amount</p>
        </th>
        <th class="row">
          <p>Checkbox</p>
        </th>
      </tr>
    </thead>
    <tbody>
    
    <!-- Row 1 -->
    @if (modalData && modalData.length > 0) {
<tr class="row">
      <td class="row">
        <p>1</p>
      </td>
      <td class="row">
        <p>{{ modalData[0]?.ACCT_DESC }}</p>
      </td>
      <td class="row">
        <p>
          <input [disabled]="true" 
                 class="form-control input-md numText number-field" 
                 format="number" 
                 type="text"
                 [ngModel]="modalData[0]?.AMOUNT">
        </p>
      </td>
      <td class="row">
        <p>
          <input [ngModel]="modalData[0]?.CHECKBOX_VALUE === 'Y'" 
                 (ngModelChange)="modalData[0].CHECKBOX_VALUE = $event ? 'Y' : 'N'; checkbox(0)"
                 type="checkbox">
        </p>
      </td>
    </tr>
}
    
    <!-- Row 2 -->
    @if (modalData && modalData.length > 1) {
<tr class="row">
      <td class="row">
        <p>2</p>
      </td>
      <td class="row">
        <p>{{ modalData[1]?.ACCT_DESC }}</p>
      </td>
      <td class="row">
        <p>
          <input class="form-control input-md numText number-field" 
                 format="number" 
                 type="text"
                 [ngModel]="modalData[1]?.AMOUNT"
                 (ngModelChange)="modalData[1].AMOUNT = $event; valuechanged()">
        </p>
      </td>
      <td class="row">
        <p>
          <input [ngModel]="modalData[1]?.CHECKBOX_VALUE === 'Y'" 
                 (ngModelChange)="modalData[1].CHECKBOX_VALUE = $event ? 'Y' : 'N'; checkbox(1)"
                 type="checkbox">
        </p>
      </td>
    </tr>
}
    </tbody>
  </table>
}
</div>

<!-- 🔴 STANDARD FOOTER STRUCTURE (SuperPrompt V6) -->
<div class="modal-footer" style="padding-top: 0 !important;" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="disable || isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" 
          type="button" 
          [disabled]="disable" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
